import {Button, Menu, MenuItem} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {WifiPoint} from '../../interfaces/WifiPoint';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  item?: WifiPoint;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  onOpen?: (type: 'wifi' | 'wifiLongTerm') => void;
}

const WifiPointItemHistoryButton = <T extends ComponentType = typeof Button>({
  // item,
  component,
  componentProps,
  children,
  onOpen,
}: Props<T>) => {
  const Component = component ?? Button;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  return (
    <>
      <Component
        {...componentProps}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {children}
      </Component>

      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onBackdropClick={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            onOpen?.('wifi');
            setAnchorEl(null);
          }}
        >
          View History
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpen?.('wifiLongTerm');
            setAnchorEl(null);
          }}
        >
          View Long Term History
        </MenuItem>
      </Menu>
    </>
  );
};

export default WifiPointItemHistoryButton;
